import React from 'react'
import './Footer.css'

export default function Footer() {
    return (
        <div className="navbar bg-dark" >
            <div className="d-block m-auto footer-pd-all">
              
                <p className='text-white'>Copyright © 2025 <a href="https://doctorpapers.com/" className='footer-bottom-link'> DoctorPapers </a>. All Rights Reserved.</p>
            </div>
        </div>
    )
}
